import React, { useEffect, useRef, useState } from "react";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';

import useFetchUserInfo from "../../apiHooks/fetch-user-info/useFetchUserInfo";
import useUserOptions from "../../componentHooks/useUserOptions";
import { HEADER } from "../../constants/header.constants";
import { HeaderConfig } from "../../config/header.config";
import ClickOutside from "../../common/outside-click/outside-click";
import { API_STATUS } from "../../constants/app.constants";
import { isLoggedInUser } from "../../utils/app.utils";
import appConfig from "../../config/app.config";

import "./header.scss";


const tabs = Object.keys(HEADER);

const Header = () => {
  const [activeTab, setActiveTab] = useState(tabs[1]);
  const [openDropDown, setOpenDropDown] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const userDropdownRef = useRef();

  const { pathname } = useLocation();
  const history = useHistory();
  const userOptions = useUserOptions();
  const { status, content: userInfo } = useFetchUserInfo();

  useEffect( () =>{
    HeaderConfig.forEach( (config) =>  {
      if (matchPath(pathname, { path: config.route, exact: true })) {
        setActiveTab(config);
      }
    })
   
  },[pathname]);

  const onTabClick = (tab) => {
    setActiveTab(tab);
    history.push(tab.route);
  };

  const onUserIconClick = () => {
    setOpenDropDown((prev) => !prev);
  };

  const onOpenMenuButtonClick = () => {
    setOpenMenu((prev) => !prev);
  };

  
  return (
    <nav className="header bg-color">
      <div className="content mx-auto px-2 sm:px-6 lg:px-8">
        <div className="relative flex header_height items-center justify-between">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
            <button
              type="button"
              className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded="false"
              onClick={onOpenMenuButtonClick}
            >
              <span className="sr-only">Open main menu</span>
             
              <svg
                className="block h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>

              <svg
                className="hidden h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
            <div className="flex flex-shrink-0 items-center">
              <img
                className="block h-8 w-auto lg:hidden"
                src={appConfig.staticAssetsUrl+"logo.png"}
                alt="Airtel"
              />
              <img
                className="hidden h-8 w-auto lg:block"
                src={appConfig.staticAssetsUrl+"logo.png"}
                alt="Airtel"
              />
              {"  "}
              <span className="text-white text-sm font-medium developer_center">
                API Marketplace
              </span>
            </div>
            <div className="hidden sm:ml-6 sm:block">
              <div className="flex space-x-4">
                {HeaderConfig.filter( ({enabled}) => enabled).map((tab) => (
                  <a
                    className={`text-gray-300 hover:bg-gray-700 hover:text-white rounded-md px-3 py-2 text-sm font-medium ${
                      activeTab.displayName === tab.displayName
                        ? "bg-gray-500"
                        : ""
                    }`}
                    onClick={() => onTabClick(tab)}
                  >
                    {tab.displayName}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div
            className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
            onClick={onUserIconClick}
          >
                 { isLoggedInUser() ? 
             <div className="user-icon"><InitialsAvatar name={`${userInfo.given_name?.trim()} ${(userInfo.family_name)?.trim()}`} className="rounded-full avatar p-2 focus:ring-white focus:ring-offset-gray-800"/> </div>:
            <button
              type="button"
              className="rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button> }
            <div className="displayName">
              {" "}
              {status === API_STATUS.SUCCESS &&  Object.values(userInfo).length > 0 &&
                `${userInfo.given_name} ${userInfo.family_name}`}
            </div>

            <div className="relative ml-3 user-icon" onClick={onUserIconClick}>
        
             <div>
                <svg
                  className="usericon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div> 
             <ClickOutside onClick={() => setOpenDropDown(false)}>
              {openDropDown && (
                <div
                  className="absolute right-0 z-10 mt-5 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="user-menu-button"
                  tabindex="-1"
                  ref={userDropdownRef}
                >
                   {userOptions
                    .filter(({ enabled }) => enabled)
                    .map((option) => (
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700"
                        role="menuitem"
                        tabindex="-1"
                        id="user-menu-item-1"
                        onClick={option.callback}
                      >
                        {option.displayName}
                      </a>
                    ))}
                  
                  {/* <a href="#" className="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-0">Your Profile</a>
            <a href="#" className="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-1">Settings</a>
            <a href="#" className="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-2">Sign out</a> */}
                </div>
              )}
             
              </ClickOutside>
            </div>
            
          </div>
        </div>
      </div>

      {openMenu && <div className="sm:hidden" id="mobile-menu">
        <div className="space-y-1 px-2 pb-3 pt-2">
        {HeaderConfig.filter( (config) => config.enabled).map((tab) => (
                  <a
                    className={`text-white block rounded-md px-3 py-2 text-base font-medium ${
                      activeTab.displayName === tab.displayName
                        ? "bg-gray-500"
                        : ""
                    }`}
                    onClick={() => onTabClick(tab)}
                  >
                    {tab.displayName}
                  </a>
                ))}
          {/* <a
            href="#"
            className="text-gray-300 hover:bg-gray-700 text-white block rounded-md px-3 py-2 text-base font-medium"
            aria-current="page"
          >
            Home
          </a>
          <a
            href="#"
            className="bg-gray-900 text-white block rounded-md px-3 py-2 text-base font-medium"
          >
            Products
          </a>
          <a
            href="#"
            className="text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium"
          >
            Support & FAQs
          </a>
          <a
            href="#"
            className="text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium"
          >
            Contact Us
          </a> */}
        </div>
      </div> }
    </nav>
  );
};

export default Header;
